module.exports = __webpack_public_path__ + "static/img/content-4.bd98892.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/content-4.png
// module id = eMNC
// module chunks = 1